import { Injectable } from '@angular/core';
import { Dashboard } from '@shared/interfaces/dashboard.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainDashboardsService {
  userDashboards = new BehaviorSubject<Dashboard[]>([]);
}
